import React from "react";
import { Mail, Lock, UserRound } from "lucide-react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export default function CommonLoginLeftPart() {
    const { t } = useTranslation();
    
    return (
        <>
            <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.2 }}
                className="hidden md:block space-y-6">
                <div className="text-2xl font-extrabold text-blue-600 flex items-center gap-3 text-left">
                    <img
                        src="https://assests.netlify.app/assets/images/logo.png"
                        alt="Kokobeo Logo"
                        className="w-12 h-12 object-contain"
                    />
                    <span>Kokobeo</span>
                </div>
                <div className="space-y-4 text-left">
                    <h1 className="text-4xl font-bold text-gray-900">{t("common.welcomeBack")}</h1>
                    <p className="text-lg text-gray-600">
                        {t("common.welcomeMessage")}
                    </p>
                </div>

                <div className="space-y-4">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                            <UserRound className="w-6 h-6 text-blue-600" />
                        </div>
                        <p className="text-gray-700">{t("common.accessDashboard")}</p>
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                            <Mail className="w-6 h-6 text-blue-600" />
                        </div>
                        <p className="text-gray-700">{t("common.manageCommunications")}</p>
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                            <Lock className="w-6 h-6 text-blue-600" />
                        </div>
                        <p className="text-gray-700">{t("common.secureProtection")}</p>
                    </div>
                </div>
            </motion.div>
        </>
    );
}
